import { Image } from '@/atoms/Image'
import { Text } from '@/atoms/Text'
import { useTranslate } from '@/utils/translate/translate-client'

export const YoungWashingtonBehindTheCamera = () => {
  const { t } = useTranslate('pif')
  return (
    <div className="my-[56px] flex flex-col px-4 md:my-[64px]">
      <Text className="photon-heading-xs md:photon-heading-sm tracking-tight" color="core-gray-950" weight="bold">
        {t('behindTheCameraWithJonErwin', 'Behind the Camera With Jon Erwin')}
      </Text>

      <Text className="photon-paragraph-sm md:photon-paragraph-md mt-3" color="core-gray-700">
        {t(
          'behindTheCameraWithJonErwinDescription',
          'Discover why this story matters. Pay it Forward today and get insider access to Jon Erwin’s Director’s Diaries, including this first look at his passion for bringing Young Washington to life.',
        )}
      </Text>

      <div style={{ aspectRatio: 16 / 9 }} className="relative mt-6 w-full">
        <Image
          src="https://images.angelstudios.com/image/upload/v1759419822/theatrical/young%20washington/yw-jerwin-bts-01.webp"
          alt="Jon Erwin Behind the Camera"
          fill
          sizes="(max-width: 1023px) 100vw, 856px"
          className="rounded-2xl object-cover"
        />
      </div>
    </div>
  )
}
